import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { configuration } from '../../../network';
import Loader from '../Loader';

export default function WithAuthentication({ children }: { children: JSX.Element }) {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | undefined>();

    async function handleToken() {
        const token = Cookies.get('accessToken');
        if (token && isAuthenticated === undefined) {
            setIsAuthenticated(true);
            configuration.setConfig({ accessToken: `Bearer ${token}` });
        } else {
            setIsAuthenticated(false);
        }
    }

    useEffect(() => {
        handleToken();
    }, []);

    if (isAuthenticated === undefined) {
        return <Loader />;
    }

    if (isAuthenticated === false) {
        return <Navigate to="/admin/login" replace={true} />;
    }

    return children;
}
